export default __webpack_public_path__ + "static/media/create-place.c6226d2e.jpg";